/* Infinitebook Plus builder: behaviour (section sections/ib-plus-builder.liquid) */
(() => {
  function initBuilder(root) {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = '1';
    // phones get lighter photos: the notebook is drawn small there, and iOS Safari has a tight memory budget
    const small = matchMedia('(max-width: 749px)').matches;
    const raw = root.querySelector('[data-ibb-data]').textContent;
    const D = JSON.parse(small ? raw.replace(/width=1800/g, 'width=1000') : raw);
    const T = D.t;
    const $ = (sel) => root.querySelector(sel);
    const fmt = new Intl.NumberFormat(D.locale, { style: 'currency', currency: D.currency });
    const money = (cents) => fmt.format(cents / 100);
    const esc = (v) => String(v).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
    const fill = (str, map) => Object.keys(map).reduce((o, k) => o.split('[' + k + ']').join(map[k]), str || '');
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- Geometry of the standard photo templates (2000×2000 px) ---- */
    const W = 876, H = 1248, R = 46, HOLES = 24, HOLE_Y0 = 47, HOLE_STEP = 50.5, HOLE = 26, HOLE_X = 27;
    const BOX = {
      cover_front: [97, 376, 969, 1621], cover_back: [1032, 376, 1899, 1621],
      stack_front: [445, 499, 1314, 1740], stack_back: [444, 498, 1314, 1741],
      single_front: [561, 373, 1440, 1628], single_back: [560, 373, 1439, 1628],
      spread_right: [1015, 428, 1865, 1640], spread_left: [125, 428, 975, 1641]
    };
    // binding on the left (front faces) or on the right (backs, as seen from behind)
    const bindLeft = (layout) => /front|right/.test(layout);
    function maskUri(left) {
      const r = R;
      let d = left
        ? `M0 0H${W - r}A${r} ${r} 0 0 1 ${W} ${r}V${H - r}A${r} ${r} 0 0 1 ${W - r} ${H}H0Z`
        : `M${r} 0H${W}V${H}H${r}A${r} ${r} 0 0 1 0 ${H - r}V${r}A${r} ${r} 0 0 1 ${r} 0Z`;
      const hx = left ? HOLE_X : W - HOLE_X;
      for (let i = 0; i < HOLES; i++) {
        const cy = HOLE_Y0 + i * HOLE_STEP;
        d += `M${hx - HOLE / 2} ${cy - HOLE / 2}h${HOLE}v${HOLE}h-${HOLE}Z`;
      }
      // double quotes inside the SVG are percent-encoded, so the url('…') can sit safely inside a style attribute
      return `url('data:image/svg+xml,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${W} ${H}" preserveAspectRatio="none"><path fill-rule="evenodd" d="${d}"/></svg>`)}')`;
    }
    const MASK = { left: maskUri(true), right: maskUri(false) };
    function cropStyle(img, layout, color) {
      const [x0, y0, x1, y1] = BOX[layout] || BOX.stack_front;
      const bw = x1 - x0, bh = y1 - y0;
      const m = MASK[bindLeft(layout) ? 'left' : 'right'];
      const bg = color
        ? `background:${color};`
        : `background-image:url('${img}');background-size:${(2000 / bw) * 100}% ${(2000 / bh) * 100}%;background-position:${(x0 / (2000 - bw)) * 100}% ${(y0 / (2000 - bh)) * 100}%;`;
      return `${bg}-webkit-mask-image:${m};mask-image:${m};`;
    }
    const crop = (img, layout, extra = '', color) => `<div class="ibb-crop ${extra}" style="${cropStyle(img, layout, color)}"></div>`;
    function ringsSvg() {
      let bars = '';
      for (let i = 0; i < HOLES; i++) bars += `<rect x="0" y="${HOLE_Y0 + i * HOLE_STEP - 8.5}" width="96" height="17" rx="8.5"/>`;
      const top = HOLE_Y0 - 8, bottom = HOLE_Y0 + (HOLES - 1) * HOLE_STEP + 8;
      return `<svg class="ibb-rings" viewBox="0 0 96 ${H}" aria-hidden="true"><g fill="#231f20">${bars}<rect x="45" y="${top}" width="5" height="${bottom - top}"/></g></svg>`;
    }

    /* ---- State ---- */
    const covers = D.covers, inserts = D.inserts, extras = D.extras;
    const state = {
      cover: (covers.find((c) => c.available) || covers[0] || {}).key,
      packs: [],
      extras: new Set(extras.filter((x) => x.preselect && x.available).map((x) => x.key)),
      opened: 0, back: false
    };
    const book = $('[data-book]'), stage = $('[data-stage]'), fit = $('[data-fit]');
    const ins = (key) => inserts.find((x) => x.key === key);
    const cov = () => covers.find((c) => c.key === state.cover);

    function packSheets(key) {
      const t = ins(key), n = t.sheets, out = [];
      for (let i = 0; i < n; i++) {
        out.push({
          f: i === 0 && t.firstFront ? t.firstFront : t.front,
          b: i === n - 1 && t.lastBack ? t.lastBack : t.back
        });
      }
      return out;
    }
    function sequence() {
      const seq = [];
      state.packs.forEach((key, p) => packSheets(key).forEach((sh, i) => seq.push({ key, pack: p, n: i + 1, ...sh })));
      return seq;
    }

    /* ---- 3D notebook ----
       The model is laid out in template units (W×H) and drawn at S of that size, so each page is
       rendered close to its on-screen size: iOS rasterises every 3D layer at its own size, ignoring
       the scale of its parents, and full-size pages used up the memory budget. */
    const S = 0.4, G = 2.4 * S, NEAR = 3;
    function build(pop) {
      const c = cov();
      if (!c) return;
      const seq = sequence();
      let html = `<div class="ibb-leaf" style="transform:translateZ(0)">
          <div class="ibb-face">${crop('', 'cover_front', '', c.inside)}</div>
          <div class="ibb-face b">${crop(c.img, 'cover_back')}</div></div>`;
      html += `<div class="ibb-leaf" data-leaf>
          <div class="ibb-face${pop ? ' ibb-pop' : ''}">${crop(c.img, 'cover_front')}</div>
          <div class="ibb-face b">${crop('', 'cover_front', 'mir', c.inside)}</div></div>`;
      seq.forEach((l) => {
        const back = l.b ? crop(l.b.img, l.b.layout) : crop(l.f.img, l.f.layout, 'mir');
        html += `<div class="ibb-leaf" data-leaf><div class="ibb-face">${crop(l.f.img, l.f.layout)}</div><div class="ibb-face b">${back}</div></div>`;
      });
      html += ringsSvg();
      book.innerHTML = html;
      state.opened = Math.min(state.opened, seq.length + 1);
      layout(true);
    }
    function layout(instant) {
      const leaves = [...book.querySelectorAll('[data-leaf]')];
      const N = leaves.length;
      leaves.forEach((el, i) => {
        const flipped = i < state.opened;
        const z = flipped ? (i + 1) * G : (N - i) * G;
        const ang = flipped ? -178 + i * 0.06 : -i * 0.02;
        el.style.transitionDelay = instant || reduce ? '0s' : `${Math.abs(i - state.opened) < 6 ? Math.abs(i - state.opened) * 0.05 : 0.3}s`;
        el.style.transform = `translateZ(${z}px) rotateY(${ang}deg)`;
      });
      // only the pages around the open spread are drawn; the rest are hidden under them anyway
      leaves.forEach((el, i) => el.classList.toggle('is-far', i > 0 && i < N - 1 && (i < state.opened - NEAR || i > state.opened + NEAR - 1)));
      book.querySelector('.ibb-rings').style.transform = `translateZ(${(N + 2) * G}px)`;
      const open = state.opened > 0 && !state.back;
      stage.classList.toggle('is-open', open);
      book.style.setProperty('--shift', open ? `${438 * S}px` : '0px');
      book.style.setProperty('--ry', state.back ? '160deg' : open ? '-6deg' : '-20deg');
      book.style.setProperty('--rx', open ? '24deg' : '16deg');
      book.style.setProperty('--rz', open ? '0deg' : '2deg');
      fitScale();
      info(N);
    }
    function fitScale() {
      const open = state.opened > 0 && !state.back;
      const needW = (open ? W * 2.4 : W * 1.3) * S, needH = H * 1.32 * S;
      fit.style.setProperty('--k', Math.min(stage.clientWidth / needW, stage.clientHeight / needH).toFixed(4));
    }
    function info(N) {
      const el = $('[data-pageinfo]'), seq = sequence(), c = cov();
      if (state.back) el.innerHTML = `<strong>${esc(T.backCover)}</strong>${esc(T.backCoverHint)}`;
      else if (state.opened === 0) el.innerHTML = `<strong>${esc(fill(T.coverOf, { name: c ? c.name : '' }))}</strong>${esc(seq.length ? T.tapToOpen : T.noInteriors)}`;
      else {
        const s = seq[state.opened - 1];
        if (!s || state.opened >= N) el.innerHTML = `<strong>${esc(T.insideBack)}</strong>${esc(T.insideBackHint)}`;
        else {
          const t = ins(s.key);
          const sub = t.labels === 'weeks' ? (s.n === 1 ? T.firstPage : fill(T.week, { n: s.n - 1 })) : fill(T.pack, { n: s.pack + 1 });
          el.innerHTML = `<strong>${esc(fill(T.sheetOf, { x: state.opened, n: seq.length }))}</strong>${esc(t.name)} · ${esc(sub)}`;
        }
      }
      $('[data-toggle]').textContent = state.back ? T.open : state.opened ? T.close : T.open;
      $('[data-prev]').disabled = !state.back && state.opened === 0;
      $('[data-next]').disabled = state.back;
      $('[data-flip]').textContent = state.back ? T.seeFront : T.seeBack;
    }
    function go(n) {
      const N = book.querySelectorAll('[data-leaf]').length;
      if (n > N) { state.back = true; state.opened = 0; layout(); return; }
      state.back = false; state.opened = Math.max(0, n); layout();
    }
    $('[data-toggle]').addEventListener('click', () => go(state.back ? 1 : state.opened ? 0 : 1));
    $('[data-next]').addEventListener('click', () => go(state.opened + 1));
    $('[data-prev]').addEventListener('click', () => go(state.back ? book.querySelectorAll('[data-leaf]').length : state.opened - 1));
    $('[data-flip]').addEventListener('click', () => { state.back = !state.back; if (state.back) state.opened = 0; layout(); });
    stage.addEventListener('click', () => { if (state.back) { state.back = false; layout(); } else go(state.opened ? state.opened + 1 : 1); });
    addEventListener('resize', fitScale);

    /* ---- Configurator ---- */
    $('[data-covers]').innerHTML = covers.map((c) => `<button class="ibb-swatch" type="button" data-cover="${c.key}" aria-pressed="false" ${c.available ? '' : 'disabled'}>
        <span class="ibb-thumb">${crop(c.img, 'cover_front')}</span>${esc(c.name)}<small>${c.available ? money(c.price) : esc(T.soldOut)}</small></button>`).join('');
    $('[data-covers]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-cover]');
      if (!b || b.dataset.cover === state.cover) return;
      state.cover = b.dataset.cover; state.back = false; state.opened = 0; build(true); render();
    });

    $('[data-inserts]').innerHTML = inserts.map((t) => `<div class="ibb-insert${t.available ? '' : ' is-off'}" data-insert="${t.key}">
        <span class="ibb-thumb">${crop(t.front.img, t.front.layout)}</span>
        <div><div class="ibb-nm">${esc(t.name)}</div><div class="ibb-pr">${esc(fill(T.packOf, { n: t.sheets }))} · ${t.available ? money(t.price) : esc(T.soldOut)}</div></div>
        <div class="ibb-qty"><button type="button" data-k="${t.key}" data-d="-1" aria-label="${esc(fill(T.remove, { name: t.name }))}">−</button><output>0</output><button type="button" data-k="${t.key}" data-d="1" aria-label="${esc(fill(T.addOne, { name: t.name }))}" ${t.available ? '' : 'disabled'}>+</button></div></div>`).join('');
    $('[data-inserts]').addEventListener('click', (e) => {
      const b = e.target.closest('[data-d]');
      if (!b || b.disabled) return;
      const key = b.dataset.k;
      if (b.dataset.d === '1') {
        state.packs.push(key);
        build(false);
        const first = state.packs.slice(0, -1).reduce((n, k) => n + ins(k).sheets, 0) + 1;
        requestAnimationFrame(() => requestAnimationFrame(() => go(first)));
      } else {
        const i = state.packs.lastIndexOf(key);
        if (i < 0) return;
        state.packs.splice(i, 1); build(false);
      }
      render();
    });

    $('[data-extras]').innerHTML = extras.map((x) => `<div class="ibb-extra${x.available ? '' : ' is-off'}" data-extra="${x.key}">
        <button class="ibb-xbtn" type="button" aria-pressed="false" ${x.available ? '' : 'disabled'}><span class="ibb-box">✓</span><span class="ibb-xname">${esc(x.name)}${x.badge ? ` <span class="ibb-badge">${esc(x.badge)}</span>` : ''}</span></button>
        ${x.help ? `<button class="ibb-help" type="button" aria-expanded="false" aria-label="${esc(fill(T.whatIs, { name: x.name }))}">?</button>` : ''}
        <span class="ibb-xprice">${x.available ? money(x.price) : esc(T.soldOut)}</span>
        ${x.help ? `<p class="ibb-tip" hidden>${esc(x.help)}</p>` : ''}</div>`).join('');
    $('[data-extras]').addEventListener('click', (e) => {
      const row = e.target.closest('[data-extra]');
      if (!row) return;
      const h = e.target.closest('.ibb-help');
      if (h) { const open = h.getAttribute('aria-expanded') !== 'true'; h.setAttribute('aria-expanded', String(open)); row.querySelector('.ibb-tip').hidden = !open; return; }
      if (e.target.closest('.ibb-tip') || row.classList.contains('is-off')) return;
      const k = row.dataset.extra;
      state.extras.has(k) ? state.extras.delete(k) : state.extras.add(k);
      render();
    });

    function lines() {
      const c = cov(), out = [];
      if (c) out.push({ id: c.id, qty: 1, name: c.name, price: c.price });
      if (D.rings) out.push({ id: D.rings.id, qty: 1, name: D.rings.title, price: D.rings.price });
      inserts.forEach((t) => {
        const q = state.packs.filter((k) => k === t.key).length;
        if (q) out.push({ id: t.id, qty: q, name: t.name, price: t.price });
      });
      extras.forEach((x) => state.extras.has(x.key) && out.push({ id: x.id, qty: 1, name: x.name, price: x.price }));
      return out;
    }
    function render() {
      root.querySelectorAll('[data-cover]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.cover === state.cover)));
      root.querySelectorAll('[data-insert]').forEach((el) => {
        const q = state.packs.filter((k) => k === el.dataset.insert).length;
        el.querySelector('output').textContent = q;
        el.classList.toggle('is-on', q > 0);
        el.querySelector('[data-d="-1"]').disabled = q === 0;
      });
      const sheets = state.packs.reduce((n, k) => n + ins(k).sheets, 0);
      const missing = Math.max(0, D.minPacks - state.packs.length);
      $('[data-sheetcount]').textContent = `${sheets} / ${D.capacity} ${T.sheets}`;
      $('[data-meter] i').style.width = Math.min(100, (sheets / D.capacity) * 100) + '%';
      $('[data-meter]').classList.toggle('is-over', sheets > D.capacity);
      $('[data-step-inserts]').classList.toggle('is-done', !missing);
      $('[data-hint]').textContent = sheets > D.capacity
        ? fill(T.hintOver, { s: sheets, cap: D.capacity })
        : !state.packs.length ? fill(T.hintStart, { min: D.minPacks })
        : missing ? fill(T.hintMissing, { n: missing }) : T.hintComplete;
      root.querySelectorAll('[data-extra]').forEach((el) => {
        const on = state.extras.has(el.dataset.extra);
        el.classList.toggle('is-on', on);
        el.querySelector('.ibb-xbtn').setAttribute('aria-pressed', String(on));
      });
      $('[data-step-extras]').classList.toggle('is-done', state.extras.size > 0);
      const L = lines();
      $('[data-lines]').innerHTML = L.map((l) => `<li><span>${l.qty > 1 ? l.qty + ' × ' : ''}${esc(l.name)}</span><span>${money(l.price * l.qty)}</span></li>`).join('');
      $('[data-total]').textContent = money(L.reduce((s, l) => s + l.price * l.qty, 0));
      const coverOk = cov() && cov().available, ringsOk = !D.rings || D.rings.available;
      $('[data-warn]').textContent = missing ? fill(T.warnMissing, { n: missing }) : '';
      $('[data-add]').disabled = !!missing || !coverOk || !ringsOk;
    }

    $('[data-add]').addEventListener('click', async () => {
      const btn = $('[data-add]'), err = $('[data-error]');
      err.textContent = '';
      btn.disabled = true; btn.classList.add('loading'); btn.setAttribute('aria-busy', 'true');
      const bundle = 'IBP-' + Date.now().toString(36).toUpperCase();
      const items = lines().map((l) => ({ id: l.id, quantity: l.qty, properties: { [T.property]: 'Infinitebook Plus', _bundle_id: bundle } }));
      try {
        const res = await fetch(D.cartAddUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || T.error);
        window.location.href = D.cartUrl;
      } catch (e) {
        err.textContent = e.message || T.error;
        btn.classList.remove('loading'); btn.removeAttribute('aria-busy'); render();
      }
    });

    /* ---- Mobile bar: total + add to cart, and a shortcut back to the preview ---- */
    const bar = $('[data-bar]'), studio = $('.ibb-studio'), summary = $('.ibb-summary'), barView = $('[data-view]');
    const scrollToEl = (el) => {
      const offset = parseFloat(getComputedStyle(root).getPropertyValue('--ibb-sticky')) || 0;
      window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - offset, behavior: reduce ? 'auto' : 'smooth' });
    };
    function updateBar() {
      if (!bar) return;
      const vh = window.innerHeight;
      const s = studio.getBoundingClientRect(), m = summary.getBoundingClientRect();
      const previewVisible = s.bottom > vh * 0.25 && s.top < vh;
      const summaryReached = m.top < vh - 40;
      const show = !previewVisible && !summaryReached;
      bar.classList.toggle('is-shown', show);
      bar.setAttribute('aria-hidden', String(!show));
    }
    if (bar) {
      let ticking = false;
      addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(() => { ticking = false; updateBar(); }); } }, { passive: true });
      addEventListener('resize', updateBar);
      barView.addEventListener('click', () => scrollToEl(studio));
      $('[data-bar-add]').addEventListener('click', () => {
        if ($('[data-add]').disabled) { scrollToEl($('[data-step-inserts]')); return; }
        $('[data-add]').click();
      });
      updateBar();
    }
    const baseRender = render;
    let lastPacks = 0;
    render = function () {
      baseRender();
      if (!bar) return;
      $('[data-bar-total]').textContent = $('[data-total]').textContent;
      // nudge the View button when the notebook changes while the preview is off screen
      if (state.packs.length !== lastPacks && bar.classList.contains('is-shown')) {
        barView.classList.remove('is-pulse'); void barView.offsetWidth; barView.classList.add('is-pulse');
      }
      lastPacks = state.packs.length;
    };

    if (!covers.length) return;
    build(false); render();
  }
  const initAll = () => document.querySelectorAll('[data-ibb]').forEach(initBuilder);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  // theme editor: re-run when the section is added or its settings change
  document.addEventListener('shopify:section:load', initAll);
})();
